import { createStore } from 'owa-satcheljs';
import {
    BannerState,
    DialogState,
    type CopilotAccountPickerStore,
} from './schema/CopilotAccountPickerStoreSchema';

const initialStore: CopilotAccountPickerStore = {
    accountOptions: [],
    currentAccount: null,
    unsavedSelectedAccount: null,
    dialogState: DialogState.CLOSED,
    bannerState: BannerState.HIDDEN,
};

export const getStore: () => CopilotAccountPickerStore = createStore<CopilotAccountPickerStore>(
    'CopilotAccountPickerStore',
    initialStore
);
